var $efe4685e2440d8be$exports = {};
$efe4685e2440d8be$exports = {
  "decrease": function decrease(args) {
    return "Decrease ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "Increase ".concat(args.fieldLabel);
  },
  "numberField": "Number field"
};
export { $efe4685e2440d8be$exports as default };